import { useCarouselContext } from '../context';

export function AdditionalInfoArea() {
  const context = useCarouselContext();
  const lens = context.lens;
  const Component = lens.AdditionalInfoArea;
  return Component ? <Component /> : <></>;
}
